import {
  HomeBanner,
  HomeColumnLeftSM,
  HomeColumnsContainerSM,
  HomeContainerSM,
  HomeContainerXS,
  HomeContentWrapperXS,
  HomeEyebrowText,
  HomeFloatingButtons,
  HomeFooterXS,
  HomeHeaderCta,
  HomeHeaderXS,
  HomeHeroCta,
  HomeHeroImagePlaceholderSM,
  HomeHeroImageSM,
  HomeHeroImageXS,
  HomeHeroText,
  HomeInfoText,
} from './components';

export const Home = {
  Banner: HomeBanner,
  ContentWrapperXS: HomeContentWrapperXS,
  ContainerXS: HomeContainerXS,
  ContainerSM: HomeContainerSM,
  EyebrowText: HomeEyebrowText,
  InfoText: HomeInfoText,
  FloatingButtons: HomeFloatingButtons,
  FooterXS: HomeFooterXS,
  HeaderCta: HomeHeaderCta,
  HeaderXS: HomeHeaderXS,
  HeroCta: HomeHeroCta,
  HeroImageXS: HomeHeroImageXS,
  HeroImageSM: HomeHeroImageSM,
  HomeHeroImagePlaceholderSM: HomeHeroImagePlaceholderSM,
  HeroText: HomeHeroText,
  ColumnsContainerSM: HomeColumnsContainerSM,
  ColumnLeftSM: HomeColumnLeftSM,
};
